import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import './Tasks.css';
import TabsState from '../../../components/TabsState';
import {Col, Row} from "react-flexbox-grid";
import TaskList from "../../../components/TaskList";
import TaskStatus from "../../Tasks/TaskStatus";
import {Breadcrumb} from "antd";
import Tasks from "../../Tasks";
import PropTypes from 'prop-types';

const RenderTasks = (props) => {
    if (props.taskList.length > 0) {
        return <TaskList
            listTitle={props.sectionName}
            onSignHandler={props.onSignEvent}
            onRequestSignatureHandler={props.onRequestSignEvent}
            onMarkNaHandler={props.onMarkNaEvent}
            onMarkTempHandler={props.onMarkTempEvent}
            onUndoHandler={props.onUndoEvent}
            tasks={props.taskList}
            projectStatus={props.projectStatus}
            projectData={props.projectData}
        />
    }
    else {
        return (
            <div className="empty-table">
                There are no tasks in this category.
            </div>
        )
    }
}

export class ProjectsTaskCk extends Component {
    static propTypes = {
        taskList: PropTypes.array,
        projectValue:PropTypes.any,
    };
    constructor(props) {
        super(props);
        this.state = {
             checklist:'',
            taskList: props.taskList,
            tasks:[],
        };
    }
    rendermethod(taskList) {
        let tasks = Object.keys(taskList).map(function (key) {
                return {name: key, tasks: taskList[key]}
            })
            this.setState({tasks});
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            taskList: nextProps.taskList
        });
        const taskList = nextProps.taskList;
        if(taskList){
            this.rendermethod(taskList);
        }
    }

    render() {
        const {checklist,tasks} = this.state;
        const {status, project} = this.props;
        const {onSignEvent, onRequestSignEvent, onMarkNaEvent, onMarkTempEvent, onUndoEvent, currentSection} = this.props;
        const {params} = this.props.match;
        return (
            <Col xs={12}>
                <Row>
                    <Breadcrumb className="breadcrumb-item">
                        <Breadcrumb.Item>
                            <Link
                                to={`/${status}/${project.id}/projecttasks`}
                                style={{fontize: "30px"}}
                            >
                                Project Tasks
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{params.checklist}</Breadcrumb.Item>
                    </Breadcrumb>
                        <Col xs={12} className="task--version--header"><strong>Task Version #: </strong>{(tasks[0]?.tasks[0]?.revisionNo) ? ('Rev ' + tasks[0]?.tasks[0]?.revisionNo) : ('N/A')}</Col>
                    <br/>
                </Row>
                {tasks.length > 0 &&
                <TabsState
                    routes={
                        tasks.map(taskList => {
                            return {
                                title: taskList.name,
                                component: () =>
                                    <RenderTasks
                                        sectionName={checklist}
                                        onSignEvent={onSignEvent}
                                        onRequestSignEvent={onRequestSignEvent}
                                        onMarkNaEvent={onMarkNaEvent}
                                        onMarkTempEvent={onMarkTempEvent}
                                        onUndoEvent={onUndoEvent}
                                        taskList={taskList.tasks}
                                        projectStatus={project.projectStatus}
                                        projectData={this.props.projectValue}
                                    />
                            }
                        })
                    }
                />}
            </Col>
        )
    }

}
export default withRouter(ProjectsTaskCk);
